const normaliseFn = (value) => {
    return value?.toString().toLowerCase().replaceAll(' ', '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim() || '';
}

const searchFn = (search, within) => {
    if (!Array.isArray(within)) {
        within = [within]
    }
    search = normaliseFn(search);
    for (const value of within) {
        if (normaliseFn(value).includes(search)) return true;
    }
    return false;
}
export default searchFn;